import Tween from "tween.ts";
import Animation from "../../../../src/animation/Animation";


export default class DancePointsAnim extends Animation {
  constructor(targetRadians: number[], duration: number, onUpdate: (radians: number[]) => void, onComp: () => void) {
    super();
    const radians = {
      radian1: 0,
      radian2: 0,
      radian3: 0
    };
    new Tween.Tween({ ...radians })
      .to({
        radian1: targetRadians[0],
        radian2: targetRadians[1],
        radian3: targetRadians[2]
      }, duration)
      .easing(Tween.Easing.Linear.None)
      .onUpdate((r) => onUpdate([r.radian1, r.radian2, r.radian3]))
      .onComplete(() => onComp())
      .start();
  }
}